import { Injectable } from '@angular/core';
import { Intercom } from '@supy-io/ngx-intercom';
import { Cargochief } from '../cargochief/cargochief.service';
import { C4UserDTO } from 'cargo-chief-commons';
import { environment } from '@environment/environment';
import { UtilService } from '../util/util.service';

@Injectable({
	providedIn: 'root',
})
export class IntercomService {
	constructor(
		public intercom: Intercom,
		private cargoChief: Cargochief,
		private utilService: UtilService
	) {}

	boot() {
		const user: C4UserDTO = this.cargoChief.getUser();
		if (!this.utilService.isNullOrUndefined(user)) {
			const intercomPayload = {
				app_id: environment.INTERCOM_APP_ID,
				user_id: user.id.toString(),
				name: `${user.firstName} ${user.lastName}`,
				email: user.email,
				phone: user.phoneNumber,
				company: {
					company_id: user.accountId,
					name: user.businessName,
				},
			};
			this.intercom.boot(intercomPayload);
		}
	}

	hideWidget() {
		this.intercom.update({
			hide_default_launcher: true,
		});
	}

	showWidget() {
		this.intercom.update({
			hide_default_launcher: false,
		});
	}

	shutdown() {
		this.intercom.shutdown();
	}

	bootAndShow() {
		this.boot();
		this.showWidget();
	}
}
